export default class CustomForm extends HTMLElement {
  constructor() {
    super();
    const $el = this as HTMLElement;
    const $atc = $el.querySelector("[atc-btn]") as HTMLElement;
    const $form = $el.querySelector("form") as HTMLFormElement;
    if (!$atc) return;
    const updateDataset = () => {
      // delay execution to ensure Alpine has updated the DOM (hidden inputs)
      setTimeout(() => {
        const props = {};
        const formData = new FormData($form);
        formData.forEach((value, key) => {
          if (key !== "id" && value !== "") {
            props[key] = value;
          }
        });
        $atc.dataset.addtocartProp1 = JSON.stringify(props);
      }, 0);
    };

    $form?.addEventListener("keyup", updateDataset);
    $form?.addEventListener("change", updateDataset);
  }
}
